export default {"src":"/_next/static/media/icon-black.40d1b3e8.svg","height":461,"width":478};